import {
    ADD_FEED_ANALYSE_REQUEST,
    ADD_FEED_ANALYSE_RESPONSE,
    ADD_FEED_APPLY_MODEL_UPDATE,
    ADD_FEED_CANCEL_MODEL_UPDATE,
    ADD_FEED_CLOSE,
    ADD_FEED_MODERATE,
    ADD_FEED_PREVIEW_REQUEST,
    ADD_FEED_PREVIEW_RESPONSE,
    ADD_FEED_PREVIEW_TYPING,
    ADD_FEED_TOGGLE_REJECTION_REASON_MODAL,
    ADD_FEED_UPDATE_IMAGE,
    ADD_FEED_UPDATE_MODEL
} from "./action-types"
import {
    itemResponse,
    updateImage,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    defaultAction
} from "./default-actions/presentation-actions"

export const addFeedPreviewTyping = previewURL => ({
    type: ADD_FEED_PREVIEW_TYPING,
    previewURL
})

export const addFeedPreview = (previewURL, token) => ({
    type: ADD_FEED_PREVIEW_REQUEST,
    previewURL,
    token
})

export const addFeedPreviewResponse = defaultAction(ADD_FEED_PREVIEW_RESPONSE)

export const addFeedAnalyseResponse = itemResponse(ADD_FEED_ANALYSE_RESPONSE)

export const addFeedAnalyseRequest = (data, isPersisting = true) => ({
    type: ADD_FEED_ANALYSE_REQUEST,
    data,
    isPersisting,
    callbackActionCreator: addFeedAnalyseResponse
})

export const addFeedModerate = (moderation, rejection_reason) => ({
    type: ADD_FEED_MODERATE,
    moderation,
    rejection_reason
})

export const addFeedClose = defaultAction(ADD_FEED_CLOSE)

export const addFeedUpdateImage = updateImage(ADD_FEED_UPDATE_IMAGE)
export const addFeedUpdateModel = updateModel(ADD_FEED_UPDATE_MODEL)
export const addFeedApplyModelUpdate = applyModelUpdate(
    ADD_FEED_APPLY_MODEL_UPDATE
)
export const addFeedCancelModelUpdate = cancelModelUpdate(
    ADD_FEED_CANCEL_MODEL_UPDATE
)

export const addFeedToggleRejectionReasonModal = isRejectReasonModalOpen => ({
    type: ADD_FEED_TOGGLE_REJECTION_REASON_MODAL,
    isRejectReasonModalOpen: isRejectReasonModalOpen
})
